import { combineLatest, Observable, ObservableInput } from 'rxjs';
import { endWith } from 'rxjs/operators';

/**
 * combinelatest which also emits an empty array if the source array is empty before completing.
 * The poor base behaviour is apparently by design (https://github.com/ReactiveX/rxjs/issues/3189#issuecomment-367392547)
 */
export const alwaysCombineLatest = <T>(sources: Array<ObservableInput<T>>): Observable<Array<T>> =>
  combineLatest(sources).pipe(endWith(new Array<T>()));
